<template>
    <div class="
      flex justify-between font-bold mb-[16px] text-[14px]

      lg:text-base
    ">
        <div>
            {{$t('BASE_PRICE')}}
        </div>
        <div>
            {{`${defaultUnitPrice}`}}
        </div>
    </div>
    <div class="
      flex justify-between font-bold mb-[16px] text-[14px]

      lg:text-base
    ">
        <div>
            {{$t('ADD_ONS')}}
        </div>
        <div>
            {{ `${customizationsPrice}` }}
        </div>
    </div>

    <div class="
      w-full h-px bg-[#CDCDCD] my-4

      lg:my-[32px]
    " />

    <div class="
      flex justify-between font-bold text-[14px]

      lg:text-base
    ">
        <div>
            {{ $t('SUB_TOTAL') }}
        </div>
        <div>
            {{`${defaultSubtotalPrice}`}}
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        name: 'OrderSummary',

        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.customizerStore.viewController;
            },

            zeroPrice() {
                return this.customizerStore.zeroPrice;
            },

            /**
             * Subtotal unit price.
             */
            defaultUnitPrice() {
                return this.customizerStore.defaultUnitPrice || this.zeroPrice;
            },

            /**
             * Subtotal unit price.
             */
            subtotalUnitPrice() {
                return this.customizerStore.subtotalUnitPrice || this.zeroPrice;
            },

            /**
             * Return if the default unit price does not equal the current unit price.
             * Uses string comparison for formatted values
             */
            isDiscounted() {
                return this.subtotalUnitPrice !== this.defaultUnitPrice;
            },

            currentStep() {
                return this.appStore.currentStep;
            },

            defaultSubtotalPrice() {
                return this.customizerStore.defaultSubtotalPrice || this.zeroPrice;
            },

            personalizations() {
                return this.customizerStore.personalizations;
            },

            customizationsPrice() {
                return this.customizerStore.customizationsPrice || this.zeroPrice;
            },
        },
    };
</script>
